import React from 'react'
import { graphql } from 'gatsby'
import get from 'lodash/get'

import Layout from '../components/Layout'
import FlippingCardTemplate from '../components/templates/FlippingCardTemplate'

const FlippingCard = ({data}) => {
  const frontmatter = get(data, 'markdownRemark.frontmatter', {})
  return (
    <Layout frontmatter={frontmatter}>
      <FlippingCardTemplate
        frontImage={frontmatter.frontImage}
        frontText={frontmatter.frontText}
        backImage={frontmatter.backImage}
        backName={frontmatter.backName}
        backWebsite={frontmatter.backWebsite}
        backEmail={frontmatter.backEmail}
        backTitle={frontmatter.backTitle}
        facebookLink={frontmatter.facebookLink}
        twitterLink={frontmatter.twitterLink}
        snapchatLink={frontmatter.snapchatLink}
        linkedinLink={frontmatter.linkedinLink}
        instagramLink={frontmatter.instagramLink}
      />
    </Layout>
  )
}

export default FlippingCard

export const pageQuery = graphql`
  query FlippingCardByID($id: String!) {
    markdownRemark(id: { eq: $id }) {
      id
      html
      frontmatter {
        templateKey
        title
        description
        favicon
        logo
        description
        frontImage
        frontText
        backImage
        backName
        backTitle
        backWebsite
        backEmail
        facebookLink
        snapchatLink
        linkedinLink
        instagramLink
        twitterLink
      }
    }
  }
`
